import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from '../components/api'


const DadosIniciativa = (props) => {

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id


    /*

    possuiReferencia
    processoEquipamentos
    tempoRetornoInvest
    custoVidaUtil
    eficienciaEnergComp
    investInicial
    impactoAmbientalComp
    tecAvancadasComp
    manutencaoReposicao
    eficienciaEnergLoca
    impactoAmbientalLoc
    tecAvancadasLoc


    comprasResp
    engenhariaResp
    admGeralResp
    outroResp

    progEficienciaEnerg
    gestaoEnergia
    politicaComprasSust


    campanhaConscien
    trocaLampadas
    retrofitEquip
    compraEquip
    iniAutogeracao
    cogeracao
    bombasCalor
    outrasIni
    outrasIniDescri


    baixaRelevancia
    resistenciaInvestir
    limitacaoInvest
    ausenciaTime
    faltaConhecimento
    dificuldadeDefinicao
    barreirasAdesao
    investInicialElevado
    baixaPercep
    baixaAdesao
    receioQuestoes
    dificLicitatorias
    dificSelecao
    medEficRetImediato
    medEficRetMedio
    medEficRetLongo
    impSolAutogeracao
    impPolEnergetica
    contratarEspec
    contratarServ
    capacitarEquipe
    partProgComContr
    partProgSemContr
    partProgEquipEficientes
    terceirizarResp
    implementarISO
    adotarRDC



    */

    

    var [energia_id, setEnergia_id] = useState()    

    var [possuiReferencia, setPossuiReferencia] = useState()
    var [processoEquipamentos, setProcessoEquipamentos] = useState()
    var [tempoRetornoInvest, setTempoRetornoInvest] = useState()
    var [custoVidaUtil, setCustoVidaUtil] = useState()
    var [eficienciaEnergComp, setEficienciaEnergComp] = useState()
    var [investInicial, setInvestInicial] = useState()
    var [impactoAmbientalComp, setImpactoAmbientalComp] = useState()
    var [tecAvancadasComp, setTecAvancadasComp] = useState()
    var [manutencaoReposicao, setManutencaoReposicao] = useState()
    var [eficienciaEnergLoca, setEficienciaEnergLoca] = useState()
    var [impactoAmbientalLoc, setImpactoAmbientalLoc] = useState()
    var [tecAvancadasLoc, setTecAvancadasLoc] = useState()


    var [comprasResp, setComprasResp] = useState(false)
    var [engenhariaResp, setEngenhariaResp] = useState(false)
    var [admGeralResp, setAdmGeralResp] = useState(false)
    var [outroResp, setOutroResp] = useState(false)

    var [progEficienciaEnerg, setProgEficienciaEnerg] = useState()
    var [gestaoEnergia, setGestaoEnergia] = useState()
    var [politicaComprasSust, setPoliticaComprasSust] = useState()


    var [campanhaConscien, setCampanhaConscien] = useState(false)
    var [trocaLampadas, setTrocaLampadas] = useState(false)
    var [retrofitEquip, setRetrofitEquip] = useState(false)
    var [compraEquip, setCompraEquip] = useState(false)
    var [iniAutogeracao, setIniAutogeracao] = useState(false)
    var [cogeracao, setCogeracao] = useState(false)
    var [bombasCalor, setBombasCalor] = useState(false)
    var [outrasIni, setOutrasIni] = useState(false)
    var [outrasIniDescri, setOutrasIniDescri] = useState('')


    var [baixaRelevancia, setBaixaRelevancia] = useState()
    var [resistenciaInvestir, setResistenciaInvestir] = useState()
    var [limitacaoInvest, setLimitacaoInvest] = useState()
    var [ausenciaTime, setAusenciaTime] = useState()
    var [faltaConhecimento, setFaltaConhecimento] = useState()
    var [dificuldadeDefinicao, setDificuldadeDefinicao] = useState()
    var [barreirasAdesao, setBarreirasAdesao] = useState()
    var [investInicialElevado, setInvestInicialElevado] = useState()
    var [baixaPercep, setBaixaPercep] = useState()
    var [baixaAdesao, setBaixaAdesao] = useState()
    var [receioQuestoes, setReceioQuestoes] = useState()
    var [dificLicitatorias, setDificLicitatorias] = useState()
    var [dificSelecao, setDificSelecao] = useState()
    var [medEficRetImediato, setMedEficRetImediato] = useState()
    var [medEficRetMedio, setMedEficRetMedio] = useState()
    var [medEficRetLongo, setMedEficRetLongo] = useState()
    var [impSolAutogeracao, setImpSolAutogeracao] = useState()
    var [impPolEnergetica, setImpPolEnergetica] = useState()
    var [contratarEspec, setContratarEspec] = useState()
    var [contratarServ, setContratarServ] = useState()
    var [capacitarEquipe, setCapacitarEquipe] = useState()
    var [partProgComContr, setPartProgComContr] = useState()
    var [partProgSemContr, setPartProgSemContr] = useState()
    var [partProgEquipEficientes, setPartProgEquipEficientes] = useState()
    var [terceirizarResp, setTerceirizarResp] = useState()
    var [implementarISO, setImplementarISO] = useState()
    var [adotarRDC, setAdotarRDC] = useState()


    function salvaEnergia() {


        if (outrasIni && outrasIniDescri == '') {

            window.toastr.error('Por favor, descreva as outras iniciativas!')
            return false

        }

        
        if (possuiReferencia == '' || processoEquipamentos == '' || tempoRetornoInvest == '' || custoVidaUtil == '' || eficienciaEnergComp == '' || investInicial == '' ||
            impactoAmbientalComp == '' || tecAvancadasComp == '' || manutencaoReposicao == '' || eficienciaEnergLoca == '' || impactoAmbientalLoc == '' || tecAvancadasLoc == '' ||
            progEficienciaEnerg == '' || gestaoEnergia == '' || politicaComprasSust == '' || baixaRelevancia == '' || resistenciaInvestir == '' || limitacaoInvest == '' || ausenciaTime == '' ||
            faltaConhecimento == '' || dificuldadeDefinicao == '' || barreirasAdesao == '' || investInicialElevado == '' || baixaPercep == '' || baixaAdesao == '' || receioQuestoes == '' ||
            dificLicitatorias == '' || dificSelecao == '' || medEficRetImediato == '' || medEficRetMedio == '' || medEficRetLongo == '' || impSolAutogeracao == '' || contratarEspec == '' ||
            contratarServ == '' || capacitarEquipe == '' || partProgComContr == '' || partProgSemContr == '' || partProgEquipEficientes == '' || terceirizarResp == '' || implementarISO == '' ||
            adotarRDC == '') {

                window.toastr.error('Por favor, preencha todos os campos obrigatórios!')
                return false

        }


        var dataPost = {

            possuiReferencia: possuiReferencia,
            processoEquipamentos: processoEquipamentos,
            tempoRetornoInvest: tempoRetornoInvest,
            custoVidaUtil: custoVidaUtil,
            eficienciaEnergComp: eficienciaEnergComp,
            investInicial: investInicial,
            impactoAmbientalComp: impactoAmbientalComp,
            tecAvancadasComp: tecAvancadasComp,
            manutencaoReposicao: manutencaoReposicao,
            eficienciaEnergLoca: eficienciaEnergLoca,
            impactoAmbientalLoc: impactoAmbientalLoc,
            tecAvancadasLoc: tecAvancadasLoc,


            comprasResp: comprasResp,
            engenhariaResp: engenhariaResp,
            admGeralResp: admGeralResp,
            outroResp: outroResp,

            progEficienciaEnerg: progEficienciaEnerg,
            gestaoEnergia: gestaoEnergia,
            politicaComprasSust: politicaComprasSust,


            campanhaConscien: campanhaConscien,
            trocaLampadas: trocaLampadas,
            retrofitEquip: retrofitEquip,
            compraEquip: compraEquip,
            iniAutogeracao: iniAutogeracao,
            cogeracao: cogeracao,
            bombasCalor: bombasCalor,
            outrasIni: outrasIni,
            outrasIniDescri: outrasIniDescri,


            baixaRelevancia: baixaRelevancia,
            resistenciaInvestir: resistenciaInvestir,
            limitacaoInvest: limitacaoInvest,
            ausenciaTime: ausenciaTime,
            faltaConhecimento: faltaConhecimento,
            dificuldadeDefinicao: dificuldadeDefinicao,
            barreirasAdesao: barreirasAdesao,
            investInicialElevado: investInicialElevado,
            baixaPercep: baixaPercep,
            baixaAdesao: baixaAdesao,
            receioQuestoes: receioQuestoes,
            dificLicitatorias: dificLicitatorias,
            dificSelecao: dificSelecao,
            medEficRetImediato: medEficRetImediato,
            medEficRetMedio: medEficRetMedio,
            medEficRetLongo: medEficRetLongo,
            impSolAutogeracao: impSolAutogeracao,
            impPolEnergetica: impPolEnergetica,
            contratarEspec: contratarEspec,
            contratarServ: contratarServ,
            capacitarEquipe: capacitarEquipe,
            partProgComContr: partProgComContr,
            partProgSemContr: partProgSemContr,
            partProgEquipEficientes: partProgEquipEficientes,
            terceirizarResp: terceirizarResp,
            implementarISO: implementarISO,
            adotarRDC: adotarRDC,
            
            
        }

        console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {

                    if (energia_id) {


                        api.put(`energiaIniciativa/${energia_id}`, dataPost).then((result) => {

                            console.log(result.data)
                            window.toastr.success('Registro salvo com sucesso!')

                        }).catch((err) => {

                            console.log(err.response)

                        })


                    } else {

                        api.post(`energiaIniciativa/${adesao_institucional_id}/${ano}`, dataPost).then((result) => {

                            //console.log(result.data[0].perfilAnual_id, '!!')
                            console.log(result.data)
                            setEnergia_id(result.data[0].energia_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            //history.push('/Obrigado')

                
                        }).catch((err) => {
                
                            console.log(err.response)
                
                        })

                    }

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    async function carregaEnergiaIniciativa() {

        //console.log(ano, adesao_institucional_id)

        

        setEnergia_id()

        setPossuiReferencia('')
        setProcessoEquipamentos('')
        setTempoRetornoInvest('')
        setCustoVidaUtil('')
        setEficienciaEnergComp('')
        setInvestInicial('')
        setImpactoAmbientalComp('')
        setTecAvancadasComp('')
        setManutencaoReposicao('')
        setEficienciaEnergLoca('')
        setImpactoAmbientalLoc('')
        setTecAvancadasLoc('')

        setComprasResp(false)
        setEngenhariaResp(false)
        setAdmGeralResp(false)
        setOutroResp(false)

        setProgEficienciaEnerg('')
        setGestaoEnergia('')
        setPoliticaComprasSust('')

        setCampanhaConscien(false)
        setTrocaLampadas(false)
        setRetrofitEquip(false)
        setCompraEquip(false)
        setIniAutogeracao(false)
        setCogeracao(false)
        setBombasCalor(false)
        setOutrasIni(false)
        setOutrasIniDescri('')


        setBaixaRelevancia('')
        setResistenciaInvestir('')
        setLimitacaoInvest('')
        setAusenciaTime('')
        setFaltaConhecimento('')
        setDificuldadeDefinicao('')
        setBarreirasAdesao('')
        setInvestInicialElevado('')
        setBaixaPercep('')
        setBaixaAdesao('')
        setReceioQuestoes('')
        setDificLicitatorias('')
        setDificSelecao('')
        setMedEficRetImediato('')
        setMedEficRetMedio('')
        setMedEficRetLongo('')
        setImpSolAutogeracao('')
        setImpPolEnergetica('')
        setContratarEspec('')
        setContratarServ('')
        setCapacitarEquipe('')
        setPartProgComContr('')
        setPartProgSemContr('')
        setPartProgEquipEficientes('')
        setTerceirizarResp('')
        setImplementarISO('')
        setAdotarRDC('')

        if (ano && adesao_institucional_id) {

            //console.log('!!!')
            await api.get(`energiaIniciativa/${adesao_institucional_id}/${ano}`).then((result) => {

                if (result.data) {

                    //console.log(result.data, '!!')
                    var data = result.data[0]
                    
                    setEnergia_id(data.energia_id)
                    setPossuiReferencia(data.possuiReferencia)

                    setProcessoEquipamentos(data.processoEquipamentos)
                    setTempoRetornoInvest(data.tempoRetornoInvest)
                    setCustoVidaUtil(data.custoVidaUtil)
                    setEficienciaEnergComp(data.eficienciaEnergComp)
                    setInvestInicial(data.investInicial)
                    setImpactoAmbientalComp(data.impactoAmbientalComp)
                    setTecAvancadasComp(data.tecAvancadasComp)
                    setManutencaoReposicao(data.manutencaoReposicao)
                    setEficienciaEnergLoca(data.eficienciaEnergLoca)
                    setImpactoAmbientalLoc(data.impactoAmbientalLoc)
                    setTecAvancadasLoc(data.tecAvancadasLoc)

                    setComprasResp(data.comprasResp)
                    setEngenhariaResp(data.engenhariaResp)
                    setAdmGeralResp(data.admGeralResp)
                    setOutroResp(data.outroResp)

                    setProgEficienciaEnerg(data.progEficienciaEnerg)
                    setGestaoEnergia(data.gestaoEnergia)
                    setPoliticaComprasSust(data.politicaComprasSust)

                    setCampanhaConscien(data.campanhaConscien)
                    setTrocaLampadas(data.trocaLampadas)
                    setRetrofitEquip(data.retrofitEquip)
                    setCompraEquip(data.compraEquip)
                    setIniAutogeracao(data.iniAutogeracao)
                    setCogeracao(data.cogeracao)
                    setBombasCalor(data.bombasCalor)
                    setOutrasIni(data.outrasIni)
                    setOutrasIniDescri(data.outrasIniDescri)


                    setBaixaRelevancia(data.baixaRelevancia)
                    setResistenciaInvestir(data.resistenciaInvestir)
                    setLimitacaoInvest(data.limitacaoInvest)
                    setAusenciaTime(data.ausenciaTime)
                    setFaltaConhecimento(data.faltaConhecimento)
                    setDificuldadeDefinicao(data.dificuldadeDefinicao)
                    setBarreirasAdesao(data.barreirasAdesao)
                    setInvestInicialElevado(data.investInicialElevado)
                    setBaixaPercep(data.baixaPercep)
                    setBaixaAdesao(data.baixaAdesao)
                    setReceioQuestoes(data.receioQuestoes)
                    setDificLicitatorias(data.dificLicitatorias)
                    setDificSelecao(data.dificSelecao)
                    setMedEficRetImediato(data.medEficRetImediato)
                    setMedEficRetMedio(data.medEficRetMedio)
                    setMedEficRetLongo(data.medEficRetLongo)
                    setImpSolAutogeracao(data.impSolAutogeracao)
                    setImpPolEnergetica(data.impPolEnergetica)
                    setContratarEspec(data.contratarEspec)
                    setContratarServ(data.contratarServ)
                    setCapacitarEquipe(data.capacitarEquipe)
                    setPartProgComContr(data.partProgComContr)
                    setPartProgSemContr(data.partProgSemContr)
                    setPartProgEquipEficientes(data.partProgEquipEficientes)
                    setTerceirizarResp(data.terceirizarResp)
                    setImplementarISO(data.implementarISO)
                    setAdotarRDC(data.adotarRDC)

                }
                
                
            }).catch((err) => {

                console.log(err.response)

            })


        }



    }


    useEffect(() => {
        

        carregaEnergiaIniciativa()


    }, [ano, adesao_institucional_id])


    return (

        <div>

                <div className="row">                               

                   

                    <div className="col-md-12">
                    

                        <b>Tomada de decisão</b>

                        <br/><br/>

                    </div>

    

                    <div className="col-md-12">
                        <div class="form-group" >
                            <label className="control-label">1. Existem referências específicas à Eficiência Energética na Política de Sustentabilidade da Instituição? *</label>
                            <select class="form-control" id="possuiReferencia" value={possuiReferencia} onChange={event => setPossuiReferencia(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="S">Sim, existem referências à Eficiência Energética na nossa Política de Sustentabilidade</option>
                                <option value="N">Não existem referências à Eficiência Energética na nossa Política de Sustentabilidade</option>
                                <option value="P">Não temos Política de Sustentabilidade documentada em nossa instituição</option>
                            </select>
                                
                            <br/>
                        </div>
                    </div>


                    <div className="col-md-12">
                        <div class="form-group" >
                            <label className="control-label">2. O processo de compra/locação de equipamentos é: *</label>
                            <select class="form-control" id="processoEquipamentos" value={processoEquipamentos} onChange={event => setProcessoEquipamentos(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="C">Centralizado: decisão gerencial</option>
                                <option value="D">Descentralizado: decisão local</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>


                    <div className="col-md-12">
                    <br/>
                    3. Com que frequência os fatores abaixo são levados em consideração na compra de novos equipamentos com alto consumo energético:
                    <br/><br/>
                    </div>


                    <div className="col-md-4">
                        <div class="form-group" >
                            <label className="control-label">a. Tempo de retorno do investimento *</label>
                            <select class="form-control" id="tempoRetornoInvest" value={tempoRetornoInvest} onChange={event => setTempoRetornoInvest(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="N" >Nunca</option>
                                <option value="E" >Em alguns casos</option>
                                <option value="S" >Sempre</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div class="form-group" >
                            <label className="control-label">b. Custo ao longo da vida útil *</label>
                            <select class="form-control" id="custoVidaUtil" value={custoVidaUtil} onChange={event => setCustoVidaUtil(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="N" >Nunca</option>
                                <option value="E" >Em alguns casos</option>
                                <option value="S" >Sempre</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div class="form-group" >
                            <label className="control-label">c. Eficiência Energética</label>
                            <select class="form-control" id="eficienciaEnergComp" value={eficienciaEnergComp} onChange={event => setEficienciaEnergComp(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="N" >Nunca</option>
                                <option value="E" >Em alguns casos</option>
                                <option value="S" >Sempre</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div class="form-group" >
                            <label className="control-label">d. Investimento inicial *</label>
                            <select class="form-control" id="investInicial" value={investInicial} onChange={event => setInvestInicial(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="N" >Nunca</option>
                                <option value="E" >Em alguns casos</option>
                                <option value="S" >Sempre</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div class="form-group" >
                            <label className="control-label">e. Impacto ambiental *</label>
                            <select class="form-control" id="impactoAmbientalComp" value={impactoAmbientalComp} onChange={event => setImpactoAmbientalComp(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="N" >Nunca</option>
                                <option value="E" >Em alguns casos</option>
                                <option value="S" >Sempre</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div class="form-group" >
                            <label className="control-label">f. Tecnologias avançadas *</label>
                            <select class="form-control" id="tecAvancadasComp" value={tecAvancadasComp} onChange={event => setTecAvancadasComp(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="N" >Nunca</option>
                                <option value="E" >Em alguns casos</option>
                                <option value="S" >Sempre</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>



                    <div className="col-md-12">
                        <br/>
                        4. Com que frequência os fatores abaixo são levados em consideração na elaboração de contratos de locação de equipamentos com alto consumo energético:
                        <br/><br/>
                    </div>


                    <div className="col-md-6">
                        <div class="form-group" >
                            <label className="control-label">a. Manutenção ou reposição pelo contratado *</label>
                            <select class="form-control" id="manutencaoReposicao" value={manutencaoReposicao} onChange={event => setManutencaoReposicao(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="N" >Nunca</option>
                                <option value="E" >Em alguns casos</option>
                                <option value="S" >Sempre</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>


                    <div className="col-md-6">
                        <div class="form-group" >
                            <label className="control-label">b. Eficiência Energética *</label>
                            <select class="form-control" id="eficienciaEnergLoca" value={eficienciaEnergLoca} onChange={event => setEficienciaEnergLoca(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="N" >Nunca</option>
                                <option value="E" >Em alguns casos</option>
                                <option value="S" >Sempre</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>


                    <div className="col-md-6">
                        <div class="form-group" >
                            <label className="control-label">c. Impacto ambiental *</label>
                            <select class="form-control" id="impactoAmbientalLoc" value={impactoAmbientalLoc} onChange={event => setImpactoAmbientalLoc(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="N" >Nunca</option>
                                <option value="E" >Em alguns casos</option>
                                <option value="S" >Sempre</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div class="form-group" >
                            <label className="control-label">d. Tecnologias avançadas *</label>
                            <select class="form-control" id="tecAvancadasLoc" value={tecAvancadasLoc} onChange={event => setTecAvancadasLoc(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="N" >Nunca</option>
                                <option value="E" >Em alguns casos</option>
                                <option value="S" >Sempre</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>



                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    5. Em relação às perguntas 3 e 4, quem é o responsável por determiná-los?
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="comprasResp" value={comprasResp} onChange={event => setComprasResp(event.target.checked)} checked={ comprasResp ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Setor de compras
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="engenhariaResp" value={engenhariaResp} onChange={event => setEngenhariaResp(event.target.checked)} checked={ engenhariaResp ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Setor de Engenharia
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="admGeralResp" value={admGeralResp} onChange={event => setAdmGeralResp(event.target.checked)}  checked={ admGeralResp ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Administração Geral
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="outroResp" value={outroResp} onChange={event => setOutroResp(event.target.checked)} checked={ outroResp ? 1 : 0}  disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Outro
                                    </td>
                                    
                                </tr>
                                
                            </tbody>
                        </Table>

                    </div>




                    <div className="col-md-12">
                        <br/>
                        <b>Iniciativas já tomadas pela organização</b>
                        <br/><br/>
                    </div>


                    <div className="col-md-4">
                        <div class="form-group" >
                            <label className="control-label">6. Sobre programas de eficiência energética, a unidade: *</label>
                            <select class="form-control" id="progEficienciaEnerg" value={progEficienciaEnerg} onChange={event => setProgEficienciaEnerg(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="P" >Possui um programa em vigor</option>
                                <option value="E" >Está desenvolvendo um</option>
                                <option value="J" >Já possuiu, mas foi encerrado</option>
                                <option value="N" >Nunca possuiu</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>


                    <div className="col-md-4">
                        <div class="form-group" >
                            <label className="control-label">7. Sobre o sistema de gestão de energia, a unidade: *</label>
                            <select class="form-control" id="gestaoEnergia" value={gestaoEnergia} onChange={event => setGestaoEnergia(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="E" >É certificada na ISO 50001</option>
                                <option value="P" >Possui um sistema de gestão interno em vigor</option>
                                <option value="D" >Está desenvolvendo um</option>
                                <option value="J" >Já possuiu, mas foi encerrado</option>
                                <option value="N" >Nunca possuiu</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div class="form-group" >
                            <label className="control-label">8. Sobre políticas de compras suntentáveis, a unidade: *</label>
                            <select class="form-control" id="politicaComprasSust" value={politicaComprasSust} onChange={event => setPoliticaComprasSust(event.target.value)} disabled>
                                <option value="">[Selecione]</option>
                                <option value="P" >Possui uma política em vigor</option>
                                <option value="E" >Está desenvolvendo uma</option>
                                <option value="J" >Já possuiu, mas foi encerrada</option>
                                <option value="N" >Nunca possuiu</option>
                                
                            </select>
                                
                            <br/>
                        </div>
                    </div>



                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    9. Quais as iniciativas de eficiência energética mais relevantes já foram praticadas em sua instituição? 
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="campanhaConscien" value={campanhaConscien} onChange={event => setCampanhaConscien(event.target.checked)} checked={ campanhaConscien ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Campanha de conscientização dos usuários do edifício
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="trocaLampadas" value={trocaLampadas} onChange={event => setTrocaLampadas(event.target.checked)} checked={ trocaLampadas ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Troca de lâmpadas
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="retrofitEquip" value={retrofitEquip} onChange={event => setRetrofitEquip(event.target.checked)} checked={ retrofitEquip ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Retrofit de equipamentos
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="compraEquip" value={compraEquip} onChange={event => setCompraEquip(event.target.checked)} checked={ compraEquip ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Compra de equipamentos com tecnologia avançada
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="iniAutogeracao" value={iniAutogeracao} onChange={event => setIniAutogeracao(event.target.checked)} checked={ iniAutogeracao ? 1 : 0} disabled />
                                        </center>
                                    </td>
                                    <td>
                                    Iniciativas de autogeração (ex: Fotovoltaica)
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="cogeracao"  value={cogeracao} onChange={event => setCogeracao(event.target.checked)}  checked={ cogeracao ? 1 : 0} disabled/>
                                        </center>
                                    </td>
                                    <td>
                                    Cogeração
                                    </td>
                                    
                                </tr>
                                

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="bombasCalor" value={bombasCalor} onChange={event => setBombasCalor(event.target.checked)}  checked={ bombasCalor ? 1 : 0} disabled/>
                                        </center>
                                    </td>
                                    <td>
                                    Bombas de calor
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                        <input type="checkbox" id="outrasIni" value={outrasIni} onChange={event => setOutrasIni(event.target.checked)} checked={ outrasIni ? 1 : 0} disabled/>
                                        </center>
                                    </td>
                                    <td>
                                    Outras
                                    </td>
                                    
                                </tr>

                                <tr style={{ display: outrasIni ? 'table-row' : 'none'}}>
                                    <td colspan="2">
                                        
                                        <input type="text" class="form-text" placeholder="Descreva..." value={outrasIniDescri} onChange={event => setOutrasIniDescri(event.target.value)} checked={ outrasIniDescri ? 1 : 0} disabled/>
                                        
                                    </td>
                                    
                                </tr>

                                
                            </tbody>
                        </Table>

                    </div>


                    <div className="col-md-12">
                        <br/>
                        <b>Barreiras, desafios e interesses</b>
                        <br/><br/>

                    </div>


                    <div className="col-md-12">


                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    10. Dentre os fatores listados a seguir, indique os que julga que representam ou representaram os maiores desafios para a implementação de ações de eficiência energética numa escala de 0 a 5, sendo 0 irrelevante e 5 extremamente dificultoso.
                                    </td>
                                </tr>
                                <tr>
                                    
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="baixaRelevancia" class="form-control" value={baixaRelevancia} onChange={event => setBaixaRelevancia(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
                                                
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                        </center>
                                    </td>
                                    <td>
                                        Baixa relevância do tema no planejamento estratégico *
                                    </td>

                                </tr>
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="resistenciaInvestir" class="form-control" value={resistenciaInvestir} onChange={event => setResistenciaInvestir(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
                                                
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                        </center>
                                    </td>
                                    <td>
                                        Resistência em investir em serviços externos (consultorias, diagnóostico energético, gestão, etc.) *
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="limitacaoInvest" class="form-control" value={limitacaoInvest} onChange={event => setLimitacaoInvest(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Limitação de investimento institucional apenas para atividades centrais para a instituição *
                                    </td>
                                    
                                </tr>


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="ausenciaTime" class="form-control" value={ausenciaTime} onChange={event => setAusenciaTime(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Ausência de um time  interno dedicado, o que dificulta a gestão de planos de ação *
                                    </td>
                                    
                                </tr>


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="faltaConhecimento" class="form-control" value={faltaConhecimento} onChange={event => setFaltaConhecimento(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Falta conhecimento/capacitação da equipe interna *
                                    </td>
                                    
                                </tr>


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="dificuldadeDefinicao" class="form-control" value={dificuldadeDefinicao} onChange={event => setDificuldadeDefinicao(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Dificuldade na definição da abordagem e de metas *
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="barreirasAdesao" class="form-control" value={barreirasAdesao} onChange={event => setBarreirasAdesao(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Barreiras à adesão de Medidas de eficiência energética *
                                    </td>
                                    
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="investInicialElevado" class="form-control" value={investInicialElevado} onChange={event => setInvestInicialElevado(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Investimento inicial muito elevado *
                                    </td>
                                    
                                </tr>   

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="baixaPercep" class="form-control" value={baixaPercep} onChange={event => setBaixaPercep(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Baixa percepção sobre o potencial de retorno financeiro *
                                    </td>
                                    
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="baixaAdesao" class="form-control"  value={baixaAdesao} onChange={event => setBaixaAdesao(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Baixa adesão interna dos funcionários *
                                    </td>
                                    
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="receioQuestoes" class="form-control" value={receioQuestoes} onChange={event => setReceioQuestoes(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Receio de infringir questões legais *
                                    </td>
                                    
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="dificLicitatorias" class="form-control" value={dificLicitatorias} onChange={event => setDificLicitatorias(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Dificuldades licitatórias *
                                    </td>
                                    
                                </tr>  
                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="dificSelecao" class="form-control" value={dificSelecao} onChange={event => setDificSelecao(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                    <option value="4" >4</option>
                                                
                                                    <option value="5" >5</option>
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Dificuldade na seleção de fornecedores ou produtos *
                                    </td>
                                    
                                </tr>  
                               
                                
                            </tbody>
                        </Table>

                    </div>



                    <div className="col-md-12">
                    
                        <br/>

                        <Table striped bordered hover>
                            
                            <tbody>
                                <tr>
                                    <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                                    11. Classifique as ações abaixo quanto ao nível de interesse que a sua organização teria em implementá-las.
                                    <br/><br/>
                                    0 - Sem interesse, 1 - Baixo interesse, 2 - Médio interesse, 3 - Alto interesse

                                    </td>
                                </tr>

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="medEficRetImediato" class="form-control" value={medEficRetImediato} onChange={event => setMedEficRetImediato(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Medidas de Eficiência Energética de Baixo Investimento e tempo de retorno imediato ou curto, com recursos próprios *
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="medEficRetMedio" class="form-control"  value={medEficRetMedio} onChange={event => setMedEficRetMedio(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Medidas de Eficiência Energética de Médio Investimento e tempo de retorno médio (meses a 1 ano), com recursos próprios *
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="medEficRetLongo" class="form-control" value={medEficRetLongo} onChange={event => setMedEficRetLongo(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Medidas de Eficiência Energética de Alto Investimento e tempo de retorno longo (anos), com recursos próprios *
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="impSolAutogeracao" class="form-control" value={impSolAutogeracao} onChange={event => setImpSolAutogeracao(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Implementar soluções de Autogeração Fotovoltaica *
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="impPolEnergetica" class="form-control" value={impPolEnergetica} onChange={event => setImpPolEnergetica(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Implementar política energética dentro do Planejamento Estratégico *
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="contratarEspec" class="form-control" value={contratarEspec} onChange={event => setContratarEspec(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Contratar especialista na área de Eficiência Energética *
                                    </td>
                                </tr>  


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="contratarServ" class="form-control" value={contratarServ} onChange={event => setContratarServ(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Contratar serviço de consultoria em Eficiência Energética *
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="capacitarEquipe" class="form-control" value={capacitarEquipe} onChange={event => setCapacitarEquipe(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Capacitar a equipe técnica atual em Eficiência Energética *
                                    </td>
                                </tr>  


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="partProgComContr" class="form-control" value={partProgComContr} onChange={event => setPartProgComContr(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Participar de Programa de Eficiência Energética (PEE*) com contrapartida *
                                    </td>
                                </tr>  

                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="partProgSemContr" class="form-control" value={partProgSemContr} onChange={event => setPartProgSemContr(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Participar de Programa de Eficiência Energética (PEE*) sem contrapartida *
                                    </td>
                                </tr>  


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="partProgEquipEficientes" class="form-control" value={partProgEquipEficientes} onChange={event => setPartProgEquipEficientes(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Participar de Programa de Compras Sustentáveis de equipamentos mais eficientes *
                                    </td>
                                </tr>  


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="terceirizarResp" class="form-control"  value={terceirizarResp} onChange={event => setTerceirizarResp(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Terceirizar a responsabilidade de Geração de Frio (Cooling as a Service) *
                                    </td>
                                </tr> 


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="implementarISO" class="form-control" value={implementarISO} onChange={event => setImplementarISO(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Implementar programa de Certificação ISO 50.001 *
                                    </td>
                                </tr> 


                                <tr>
                                    <td style={{width: '120px'}}>
                                        <center>
                                            <select id="adotarRDC" class="form-control" value={adotarRDC} onChange={event => setAdotarRDC(event.target.value)} disabled>
                                                <option value="">[Selecione]</option>
				 		
                                                    <option value="0" >0</option>
                                                
                                                    <option value="1" >1</option>
                                                
                                                    <option value="2" >2</option>
                                                
                                                    <option value="3" >3</option>
                                                
                                                
                                            </select>
                                                
                                        </center>
                                    </td>
                                    <td>
                                        Adotar RDC - Regime Diferenciado de Contratação - Contrato de Desempenho**
                                    </td>
                                </tr> 

                            </tbody>
                        </Table>

                    </div>

                    <div className="col-md-12">
                    
                        <br/>

                            <i>
                            * PEE é um programa regulado e fiscalizado pela Agência Nacional de Energia Elétrica (ANEEL), mas aplicado pelas concessionárias, e tem o objetivo principal de promover o uso eficiente da energia elétrica através da utilização inteligente da energia elétrica e obras de eficientização dos sistemas energéticos. 
                            <br/><br/>
                            ** onde os custos referentes às ações de Eficiência Energética são pagos a partir do ganho em desempenho e performance.
                            </i>

                    </div>






                </div>


                

        </div>
    )

}

export default DadosIniciativa